import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function StarIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15.1288 1.54558C15.5114 0.866932 16.4886 0.86693 16.8712 1.54557L20.8537 8.61139C20.9964 8.86456 21.2422 9.04313 21.5271 9.10062L29.4778 10.7048C30.2414 10.8589 30.5434 11.7883 30.0162 12.3618L24.5269 18.333C24.3302 18.5469 24.2363 18.8359 24.2697 19.1246L25.2009 27.1818C25.2903 27.9557 24.4997 28.5301 23.7913 28.2059L16.4162 24.8305C16.1519 24.7095 15.8481 24.7095 15.5838 24.8305L8.20868 28.2059C7.50032 28.5301 6.70969 27.9557 6.79913 27.1818L7.73033 19.1246C7.76369 18.8359 7.66981 18.5469 7.47312 18.333L1.98383 12.3619C1.4566 11.7883 1.75859 10.8589 2.52222 10.7048L10.4729 9.10062C10.7578 9.04313 11.0036 8.86456 11.1463 8.61139L15.1288 1.54558Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
